(() => {
  // Block native blog comment redirects before any other handler runs.
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target && event.target.closest
        ? event.target.closest('[data-prw-write-form]')
        : null;
      if (form) event.preventDefault();
    },
    true
  );

  const sanitize = (value) =>
    String(value || '')
      .replace(/\|/g, '/')
      .replace(/\[\/?prw\]/gi, '')
      .trim();

  const relativeLabelToDays = (label) => {
    const text = String(label || '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, ' ');
    if (!text) return null;
    if (text === 'TODAY' || text === 'JUST NOW') return 0;
    const match = text.match(/^(\d+)\s+(DAY|DAYS|WEEK|WEEKS|MONTH|MONTHS)\s+AGO$/);
    if (!match) return null;
    const count = Number(match[1]);
    const unit = match[2];
    if (unit.indexOf('DAY') === 0) return count;
    if (unit.indexOf('WEEK') === 0) return count * 7;
    if (unit.indexOf('MONTH') === 0) return count * 30;
    return null;
  };

  const daysToRelativeLabel = (days) => {
    const n = Math.max(0, Math.floor(Number(days) || 0));
    if (n < 1) return 'TODAY';
    if (n < 7) return n === 1 ? '1 DAY AGO' : `${n} DAYS AGO`;
    if (n < 30) {
      const weeks = Math.max(1, Math.floor(n / 7));
      return weeks === 1 ? '1 WEEK AGO' : `${weeks} WEEKS AGO`;
    }
    const months = Math.max(1, Math.floor(n / 30));
    return months === 1 ? '1 MONTH AGO' : `${months} MONTHS AGO`;
  };

  const daysSinceFreeze = (freeze) => {
    const match = String(freeze || '2026-09-21').match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match) return 0;
    const freezeUtc = Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    const now = new Date();
    const todayUtc = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
    return Math.max(0, Math.floor((todayUtc - freezeUtc) / 86400000));
  };

  const ageStaticReviewDates = (root) => {
    root.querySelectorAll('[data-prw-date-days]').forEach((el) => {
      const base = Number(el.getAttribute('data-prw-date-days') || 0);
      const freeze = el.getAttribute('data-prw-date-freeze') || '2026-09-21';
      el.textContent = daysToRelativeLabel(base + daysSinceFreeze(freeze));
    });
  };

  const getDateScore = (el) => {
    const label = el.querySelector('.prw__content-date');
    const days = relativeLabelToDays(label ? label.textContent : '');
    const stored = Number(el.dataset.date || 0);
    if (days === null) return stored;
    return Math.floor(Date.now() / 1000) - days * 86400;
  };

  const findWriteOverlay = (fromEl) => {
    const sectionEl = fromEl && fromEl.closest ? fromEl.closest('.shopify-section') : null;
    if (sectionEl) {
      const local = sectionEl.querySelector('[data-prw-write]');
      if (local) return local;
    }
    return document.querySelector('[data-prw-write]');
  };

  const openWrite = (write) => {
    if (!write) return;
    if (write.parentElement !== document.body) {
      document.body.appendChild(write);
    }
    write.classList.remove('is-thanks');
    const thanks = write.querySelector('[data-prw-write-thanks]');
    const form = write.querySelector('[data-prw-write-form]');
    const title = write.querySelector('[data-prw-write-title]');
    if (thanks) {
      thanks.hidden = true;
      thanks.setAttribute('hidden', '');
    }
    if (form) {
      form.hidden = false;
      form.removeAttribute('hidden');
    }
    if (title) {
      const defaultTitle = title.getAttribute('data-prw-default-title') || title.textContent;
      title.textContent = defaultTitle;
    }
    write.hidden = false;
    write.removeAttribute('hidden');
    document.body.classList.add('prw-write-open');
    const first = write.querySelector('[data-prw-star]');
    if (first) first.focus();
  };

  const showWriteThanks = (write) => {
    if (!write) return;
    write.classList.add('is-thanks');
    const thanks = write.querySelector('[data-prw-write-thanks]');
    const form = write.querySelector('[data-prw-write-form]');
    const title = write.querySelector('[data-prw-write-title]');
    if (form) {
      form.hidden = true;
      form.setAttribute('hidden', '');
    }
    if (thanks) {
      thanks.hidden = false;
      thanks.removeAttribute('hidden');
    }
    if (title) title.textContent = 'Thank you';
    write.hidden = false;
    write.removeAttribute('hidden');
    document.body.classList.add('prw-write-open');
    const closeBtn = write.querySelector('[data-prw-write-close]');
    if (closeBtn) closeBtn.focus();
  };

  const closeWrite = (write) => {
    if (!write) return;
    write.hidden = true;
    write.setAttribute('hidden', '');
    write.classList.remove('is-thanks');
    document.body.classList.remove('prw-write-open');
  };

  const bindWriteForm = (root, write) => {
    if (!write || write.dataset.prwWriteBound === 'true') return;
    const form = write.querySelector('[data-prw-write-form]');
    if (!form) return;
    write.dataset.prwWriteBound = 'true';

    form.removeAttribute('action');
    form.removeAttribute('method');
    form.setAttribute('novalidate', 'novalidate');
    form.onsubmit = () => false;
    form.submit = () => {
      if (typeof form.__prwHandleSubmit === 'function') form.__prwHandleSubmit();
    };

    const ratingValue = form.querySelector('[data-prw-rating-value]');
    const starBtns = form.querySelectorAll('[data-prw-star]');
    const bodyField = form.querySelector('[data-prw-body-field]');
    const authorField = form.querySelector('[data-prw-author-field]');
    const errorEl = form.querySelector('[data-prw-form-error]');
    const submitBtn = form.querySelector('[data-prw-submit]');
    const nameInput = form.querySelector('[data-prw-field="name"]');
    const emailInput = form.querySelector('[data-prw-field="email"]');
    const productId = (root && root.dataset.prwProductId) || '';
    const googleClientId = (root && root.dataset.prwGoogleClientId) || '';
    const facebookAppId = (root && root.dataset.prwFacebookAppId) || '';
    const oauthCallback =
      (root && root.dataset.prwOauthCallback) ||
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'pages/prw-social-callback'
        : '/pages/prw-social-callback');
    const socialFallback =
      (root && root.dataset.prwSocialFallback) ||
      'Enter your name and email below.';

    let rating = 0;
    let purchases = '';
    let age = '';
    let gender = '';
    const concerns = new Set();
    const mediaFiles = [];
    let avatarFile = null;
    let socialProvider = '';
    let googleTokenClient = null;
    let facebookReady = null;

    const setError = (message) => {
      if (!errorEl) return;
      if (!message) {
        errorEl.hidden = true;
        errorEl.textContent = '';
        return;
      }
      errorEl.hidden = false;
      errorEl.textContent = message;
    };

    const paintStars = (hover = 0) => {
      starBtns.forEach((btn) => {
        const value = Number(btn.getAttribute('data-prw-star') || 0);
        const active = value <= rating;
        const hovered = hover > 0 && value <= hover;
        btn.classList.toggle('is-active', active);
        btn.classList.toggle('is-hover', hovered);
        btn.setAttribute('aria-checked', value === rating ? 'true' : 'false');
      });
      if (ratingValue) ratingValue.value = String(rating);
    };

    starBtns.forEach((btn) => {
      const value = Number(btn.getAttribute('data-prw-star') || 0);
      btn.addEventListener('click', () => {
        rating = value;
        paintStars();
        setError('');
      });
      btn.addEventListener('mouseenter', () => paintStars(value));
      btn.addEventListener('mouseleave', () => paintStars());
    });

    const bindExclusive = (selector, onPick) => {
      form.querySelectorAll(selector).forEach((btn) => {
        btn.addEventListener('click', () => {
          const group = btn.parentElement;
          if (group) {
            group.querySelectorAll(selector).forEach((el) => {
              el.classList.remove('is-active');
              el.setAttribute('aria-checked', 'false');
            });
          }
          btn.classList.add('is-active');
          btn.setAttribute('aria-checked', 'true');
          onPick(btn);
        });
      });
    };

    bindExclusive('[data-prw-purchase-opt]', (btn) => {
      purchases = btn.getAttribute('data-prw-purchase-opt') || '';
    });
    bindExclusive('[data-prw-age-opt]', (btn) => {
      age = btn.getAttribute('data-prw-age-opt') || '';
    });
    bindExclusive('[data-prw-gender-opt]', (btn) => {
      gender = btn.getAttribute('data-prw-gender-opt') || '';
    });

    form.querySelectorAll('[data-prw-concern-opt]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const value = btn.getAttribute('data-prw-concern-opt') || '';
        if (!value) return;
        if (concerns.has(value)) {
          concerns.delete(value);
          btn.classList.remove('is-active');
          btn.setAttribute('aria-pressed', 'false');
        } else {
          if (concerns.size >= 5) {
            setError(
              (root && root.dataset.prwErrorConcerns) ||
                'Please select up to 5 wellness concerns.'
            );
            return;
          }
          concerns.add(value);
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
          setError('');
        }
      });
    });

    const renderPreviews = (container, files, onRemove) => {
      if (!container) return;
      container.innerHTML = '';
      if (!files.length) {
        container.hidden = true;
        return;
      }
      container.hidden = false;
      files.forEach((file, index) => {
        const item = document.createElement('div');
        item.className = 'prw-write__preview';
        const url = URL.createObjectURL(file);
        if (file.type.startsWith('video/')) {
          const video = document.createElement('video');
          video.src = url;
          video.muted = true;
          video.playsInline = true;
          item.appendChild(video);
        } else {
          const img = document.createElement('img');
          img.src = url;
          img.alt = file.name || 'Upload preview';
          item.appendChild(img);
        }
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'prw-write__preview-remove';
        remove.setAttribute('aria-label', 'Remove');
        remove.textContent = '×';
        remove.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          onRemove(index);
        });
        item.appendChild(remove);
        container.appendChild(item);
      });
    };

    const bindUploadZone = ({
      drop,
      input,
      previews,
      multiple,
      maxCount,
      acceptTest,
      getFiles,
      setFiles,
    }) => {
      if (!drop || !input) return;

      const sync = () => {
        renderPreviews(previews, getFiles(), (index) => {
          const next = getFiles().slice();
          next.splice(index, 1);
          setFiles(next);
          sync();
        });
      };

      const addFiles = (list) => {
        const incoming = Array.from(list || []).filter((file) => acceptTest(file));
        if (!incoming.length) return;
        let next = multiple ? getFiles().concat(incoming) : incoming.slice(0, 1);
        if (multiple && next.length > maxCount) {
          next = next.slice(0, maxCount);
          setError(
            (root && root.dataset.prwErrorMedia) ||
              `You can upload up to ${maxCount} photos or videos.`
          );
        } else {
          setError('');
        }
        setFiles(next);
        sync();
      };

      input.addEventListener('change', () => {
        addFiles(input.files);
        input.value = '';
      });

      ['dragenter', 'dragover'].forEach((type) => {
        drop.addEventListener(type, (event) => {
          event.preventDefault();
          drop.classList.add('is-dragover');
        });
      });
      ['dragleave', 'drop'].forEach((type) => {
        drop.addEventListener(type, (event) => {
          event.preventDefault();
          drop.classList.remove('is-dragover');
        });
      });
      drop.addEventListener('drop', (event) => {
        addFiles(event.dataTransfer && event.dataTransfer.files);
      });
    };

    bindUploadZone({
      drop: form.querySelector('[data-prw-media-drop]'),
      input: form.querySelector('[data-prw-media-input]'),
      previews: form.querySelector('[data-prw-media-previews]'),
      multiple: true,
      maxCount: 5,
      acceptTest: (file) =>
        file && (file.type.startsWith('image/') || file.type.startsWith('video/')),
      getFiles: () => mediaFiles,
      setFiles: (next) => {
        mediaFiles.length = 0;
        next.forEach((file) => mediaFiles.push(file));
      },
    });

    bindUploadZone({
      drop: form.querySelector('[data-prw-avatar-drop]'),
      input: form.querySelector('[data-prw-avatar-input]'),
      previews: form.querySelector('[data-prw-avatar-preview]'),
      multiple: false,
      maxCount: 1,
      acceptTest: (file) => file && file.type.startsWith('image/'),
      getFiles: () => (avatarFile ? [avatarFile] : []),
      setFiles: (next) => {
        avatarFile = next[0] || null;
      },
    });

    const loadScript = (src, id) =>
      new Promise((resolve, reject) => {
        if (id && document.getElementById(id)) {
          resolve();
          return;
        }
        const existing = Array.from(document.scripts).find((s) => s.src === src);
        if (existing) {
          if (existing.dataset.loaded === 'true') resolve();
          else existing.addEventListener('load', () => resolve(), { once: true });
          return;
        }
        const script = document.createElement('script');
        if (id) script.id = id;
        script.src = src;
        script.async = true;
        script.onload = () => {
          script.dataset.loaded = 'true';
          resolve();
        };
        script.onerror = () => reject(new Error('Failed to load ' + src));
        document.head.appendChild(script);
      });

    const absoluteCallbackUrl = () => {
      try {
        return new URL(oauthCallback, window.location.origin).toString();
      } catch (err) {
        return window.location.origin + '/pages/prw-social-callback';
      }
    };

    const openCenteredPopup = (url, name) => {
      const width = 520;
      const height = 640;
      const left = Math.max(0, Math.round(window.screenX + (window.outerWidth - width) / 2));
      const top = Math.max(0, Math.round(window.screenY + (window.outerHeight - height) / 2));
      const features = [
        'popup=yes',
        'toolbar=no',
        'menubar=no',
        'width=' + width,
        'height=' + height,
        'left=' + left,
        'top=' + top,
      ].join(',');
      const popup = window.open(url, name, features);
      if (popup) popup.focus();
      return popup;
    };

    const fillProfile = (name, email, provider) => {
      if (name && nameInput) nameInput.value = name;
      if (email && emailInput) emailInput.value = email;
      socialProvider = provider || '';
      setError('');
      form.querySelectorAll('[data-prw-social-btn]').forEach((btn) => {
        btn.classList.toggle('is-connected', btn.getAttribute('data-prw-social') === provider);
      });
    };

    const fetchGoogleProfile = async (accessToken) => {
      const res = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
        headers: { Authorization: 'Bearer ' + accessToken },
      });
      if (!res.ok) throw new Error('Google profile failed');
      const profile = await res.json();
      fillProfile(profile.name || '', profile.email || '', 'google');
    };

    const fetchFacebookProfile = async (accessToken) => {
      const res = await fetch(
        'https://graph.facebook.com/me?fields=name,email&access_token=' +
          encodeURIComponent(accessToken)
      );
      if (!res.ok) throw new Error('Facebook profile failed');
      const profile = await res.json();
      fillProfile(profile.name || '', profile.email || '', 'facebook');
    };

    const waitForOAuthMessage = (provider, popup) =>
      new Promise((resolve, reject) => {
        let settled = false;
        const finish = (fn, value) => {
          if (settled) return;
          settled = true;
          window.clearInterval(timer);
          window.removeEventListener('message', onMessage);
          fn(value);
        };
        const onMessage = (event) => {
          if (event.origin !== window.location.origin) return;
          const data = event.data || {};
          if (data.source !== 'prw-social-oauth') return;
          if (data.provider && data.provider !== provider) return;
          if (data.error) {
            finish(reject, new Error(data.error_description || data.error));
            return;
          }
          if (data.access_token) finish(resolve, data.access_token);
        };
        window.addEventListener('message', onMessage);
        const timer = window.setInterval(() => {
          if (popup && popup.closed) {
            finish(reject, new Error('popup_closed'));
          }
        }, 400);
      });

    const ensureGoogleClient = async () => {
      if (!googleClientId) throw new Error('missing_google_client');
      await loadScript('https://accounts.google.com/gsi/client', 'prw-google-gsi');
      if (!window.google || !window.google.accounts || !window.google.accounts.oauth2) {
        throw new Error('Google Identity Services unavailable');
      }
      if (!googleTokenClient) {
        googleTokenClient = window.google.accounts.oauth2.initTokenClient({
          client_id: googleClientId,
          scope: 'openid email profile',
          prompt: 'select_account',
          callback: () => {},
          error_callback: () => {},
        });
      }
      return googleTokenClient;
    };

    const ensureFacebook = async () => {
      if (!facebookAppId) throw new Error('missing_facebook_app');
      if (facebookReady) return facebookReady;
      facebookReady = (async () => {
        if (!window.FB) {
          await new Promise((resolve, reject) => {
            const prev = window.fbAsyncInit;
            window.fbAsyncInit = function () {
              if (typeof prev === 'function') prev();
              resolve();
            };
            loadScript('https://connect.facebook.net/fr_FR/sdk.js', 'prw-facebook-sdk').catch(
              reject
            );
            // SDK may already be present and have skipped fbAsyncInit
            window.setTimeout(() => {
              if (window.FB) resolve();
            }, 1200);
          });
        }
        window.FB.init({
          appId: facebookAppId,
          cookie: true,
          xfbml: false,
          version: 'v21.0',
        });
        return window.FB;
      })();
      return facebookReady;
    };

    const continueWithGoogle = async () => {
      if (!googleClientId) {
        setError(socialFallback);
        if (nameInput) nameInput.focus();
        return;
      }
      setError('');
      try {
        // Prefer official Google Identity Services popup (account chooser).
        const client = await ensureGoogleClient();
        await new Promise((resolve, reject) => {
          client.callback = async (tokenResponse) => {
            try {
              if (!tokenResponse || !tokenResponse.access_token) {
                reject(new Error('Google login cancelled'));
                return;
              }
              await fetchGoogleProfile(tokenResponse.access_token);
              resolve();
            } catch (err) {
              reject(err);
            }
          };
          client.error_callback = (err) => {
            reject(err || new Error('Google popup failed'));
          };
          client.requestAccessToken({ prompt: 'select_account' });
        });
      } catch (err) {
        // Fallback: classic OAuth popup → callback page
        try {
          const redirectUri = absoluteCallbackUrl();
          const url =
            'https://accounts.google.com/o/oauth2/v2/auth' +
            '?client_id=' +
            encodeURIComponent(googleClientId) +
            '&redirect_uri=' +
            encodeURIComponent(redirectUri) +
            '&response_type=token' +
            '&scope=' +
            encodeURIComponent('openid email profile') +
            '&prompt=select_account' +
            '&include_granted_scopes=true' +
            '&state=google';
          const popup = openCenteredPopup(url, 'prw_google_oauth');
          if (!popup) throw new Error('popup_blocked');
          const accessToken = await waitForOAuthMessage('google', popup);
          await fetchGoogleProfile(accessToken);
        } catch (fallbackErr) {
          setError(socialFallback);
          if (nameInput) nameInput.focus();
        }
      }
    };

    const continueWithFacebook = async () => {
      if (!facebookAppId) {
        setError(socialFallback);
        if (nameInput) nameInput.focus();
        return;
      }
      setError('');
      try {
        const FB = await ensureFacebook();
        await new Promise((resolve, reject) => {
          FB.login(
            (response) => {
              if (!response || !response.authResponse || !response.authResponse.accessToken) {
                reject(new Error('Facebook login cancelled'));
                return;
              }
              FB.api('/me', { fields: 'name,email' }, (profile) => {
                if (!profile || profile.error) {
                  reject(new Error('Facebook profile failed'));
                  return;
                }
                fillProfile(profile.name || '', profile.email || '', 'facebook');
                resolve();
              });
            },
            { scope: 'public_profile,email', return_scopes: true, auth_type: 'rerequest' }
          );
        });
      } catch (err) {
        try {
          const redirectUri = absoluteCallbackUrl();
          const url =
            'https://www.facebook.com/v21.0/dialog/oauth' +
            '?client_id=' +
            encodeURIComponent(facebookAppId) +
            '&redirect_uri=' +
            encodeURIComponent(redirectUri + (redirectUri.includes('?') ? '&' : '?') + 'provider=facebook') +
            '&response_type=token' +
            '&scope=' +
            encodeURIComponent('email,public_profile') +
            '&display=popup';
          const popup = openCenteredPopup(url, 'prw_facebook_oauth');
          if (!popup) throw new Error('popup_blocked');
          const accessToken = await waitForOAuthMessage('facebook', popup);
          await fetchFacebookProfile(accessToken);
        } catch (fallbackErr) {
          setError(socialFallback);
          if (nameInput) nameInput.focus();
        }
      }
    };

    form.querySelectorAll('[data-prw-social-btn]').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const provider = btn.getAttribute('data-prw-social');
        if (provider === 'google') continueWithGoogle();
        else if (provider === 'facebook') continueWithFacebook();
      });
    });

    // Warm SDKs when the write form is available so the first click opens instantly.
    if (googleClientId) ensureGoogleClient().catch(() => {});
    if (facebookAppId) ensureFacebook().catch(() => {});

    const fileToDataUrl = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(String(reader.result || ''));
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });

    const compressImage = (file, maxSide = 1280, quality = 0.72) =>
      new Promise((resolve) => {
        if (!file.type.startsWith('image/')) {
          resolve(null);
          return;
        }
        const img = new Image();
        const url = URL.createObjectURL(file);
        img.onload = () => {
          const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
          const width = Math.max(1, Math.round(img.width * scale));
          const height = Math.max(1, Math.round(img.height * scale));
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);
          URL.revokeObjectURL(url);
          resolve(canvas.toDataURL('image/jpeg', quality));
        };
        img.onerror = () => {
          URL.revokeObjectURL(url);
          resolve(null);
        };
        img.src = url;
      });

    let submitting = false;

    const handleSubmit = async (event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (submitting) return;

      const title = sanitize(form.querySelector('[data-prw-field="title"]')?.value);
      const body = sanitize(form.querySelector('[data-prw-field="body"]')?.value);
      const name = sanitize(form.querySelector('[data-prw-field="name"]')?.value);
      const agree = form.querySelector('[data-prw-field="agree"]')?.checked;
      const recommend = form.querySelector('[data-prw-field="recommend"]')?.checked;

      if (!rating) {
        setError(
          (root && root.dataset.prwErrorRating) || 'Please select a star rating.'
        );
        return;
      }
      if (!title || !body || !name || !agree) {
        setError('Please complete all required fields.');
        return;
      }
      if (concerns.size > 5) {
        setError(
          (root && root.dataset.prwErrorConcerns) ||
            'Please select up to 5 wellness concerns.'
        );
        return;
      }

      if (submitBtn) submitBtn.disabled = true;
      submitting = true;

      try {
        const mediaToken =
          'prw_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
        const storedMedia = [];
        for (const file of mediaFiles.slice(0, 5)) {
          if (file.type.startsWith('image/')) {
            const dataUrl = await compressImage(file);
            if (dataUrl) storedMedia.push({ type: 'image', name: file.name, dataUrl });
          } else if (file.type.startsWith('video/')) {
            // Keep videos out of comment payload; store locally for same-browser display only.
            const dataUrl = await fileToDataUrl(file).catch(() => null);
            if (dataUrl && dataUrl.length < 1800000) {
              storedMedia.push({ type: 'video', name: file.name, dataUrl });
            } else {
              storedMedia.push({ type: 'video', name: file.name, dataUrl: '' });
            }
          }
        }
        let avatarDataUrl = '';
        if (avatarFile) {
          avatarDataUrl = (await compressImage(avatarFile, 320, 0.75)) || '';
        }

        try {
          localStorage.setItem(
            'prw_media_' + mediaToken,
            JSON.stringify({
              media: storedMedia,
              avatar: avatarDataUrl,
              provider: socialProvider,
            })
          );
        } catch (err) {
          /* quota / private mode */
        }

        const meta = [
          `product_id=${sanitize(productId)}`,
          `rating=${rating}`,
          `title=${title}`,
          `purchases=${sanitize(purchases)}`,
          `concerns=${sanitize(Array.from(concerns).join(', '))}`,
          `age=${sanitize(age)}`,
          `gender=${sanitize(gender)}`,
          `recommend=${recommend ? 'yes' : 'no'}`,
          `media_count=${storedMedia.length}`,
          `media_token=${mediaToken}`,
          `has_media=${storedMedia.length ? '1' : '0'}`,
          `social=${sanitize(socialProvider)}`,
        ].join('|');

        if (authorField) authorField.value = name;
        if (bodyField) bodyField.value = `[prw]\n${meta}\n[/prw]\n${body}`;

        try {
          sessionStorage.removeItem('prw_posted');
        } catch (e) {
          /* ignore */
        }

        const commentAction =
          form.getAttribute('data-prw-comment-action') || form.getAttribute('action') || '';

        try {
          if (commentAction) {
            await fetch(commentAction, {
              method: 'POST',
              body: new FormData(form),
              credentials: 'same-origin',
              redirect: 'manual',
              headers: {
                Accept: 'text/html,application/xhtml+xml',
              },
            });
          }
        } catch (err) {
          /* Comment may still have been created; stay on page either way. */
        }

        showWriteThanks(write);
      } finally {
        if (submitBtn) submitBtn.disabled = false;
        submitting = false;
      }
    };

    form.__prwHandleSubmit = handleSubmit;
    form.addEventListener('submit', handleSubmit);
    if (submitBtn) submitBtn.setAttribute('type', 'button');
  };

  // Global delegation so the button always opens, even if section init order glitches
  if (!window.__prwWriteDelegated) {
    window.__prwWriteDelegated = true;

    document.addEventListener('click', (event) => {
      const submitBtn = event.target.closest('[data-prw-submit]');
      if (submitBtn) {
        const form = submitBtn.closest('[data-prw-write-form]');
        const write = form ? form.closest('[data-prw-write]') || findWriteOverlay(form) : null;
        const root =
          (write && write.closest('.shopify-section')?.querySelector('.prw')) ||
          document.querySelector('.prw');
        if (form && write) {
          event.preventDefault();
          bindWriteForm(root, write);
          if (typeof form.__prwHandleSubmit === 'function') {
            form.__prwHandleSubmit(event);
          }
        }
        return;
      }

      const openBtn = event.target.closest('[data-prw-write-open]');
      if (openBtn) {
        event.preventDefault();
        const write = findWriteOverlay(openBtn);
        const root =
          openBtn.closest('.prw') ||
          (write && write.closest('.shopify-section')?.querySelector('.prw')) ||
          document.querySelector('.prw');
        if (write) {
          bindWriteForm(root, write);
          openWrite(write);
        }
        return;
      }

      const writeRoot = event.target.closest('[data-prw-write]');
      if (!writeRoot || writeRoot.hidden) return;

      const closeBtn = event.target.closest('[data-prw-write-close]');
      const clickedOutsideDialog =
        !event.target.closest('[data-prw-write-dialog]') &&
        (event.target === writeRoot ||
          event.target.classList.contains('prw-write__backdrop') ||
          closeBtn);

      if (closeBtn || clickedOutsideDialog) {
        event.preventDefault();
        closeWrite(writeRoot);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-prw-write]:not([hidden])').forEach((write) => {
        closeWrite(write);
      });
    });
  }

  const init = (root) => {
    if (!root || root.dataset.prwReady === 'true') return;
    root.dataset.prwReady = 'true';

    const tabs = root.querySelectorAll('[data-prw-tab]');
    const panels = root.querySelectorAll('[data-prw-panel]');
    const list = root.querySelector('[data-prw-list]');
    const sortPicker = root.querySelector('[data-prw-sort-picker]');
    const sortToggle = sortPicker && sortPicker.querySelector('[data-prw-sort-toggle]');
    const sortMenu = sortPicker && sortPicker.querySelector('.prw__sort-menu');
    const sortLabel = sortToggle && sortToggle.querySelector('.prw__sort-label');
    const sortOptions = sortPicker
      ? Array.from(sortPicker.querySelectorAll('[data-prw-sort-option]'))
      : [];
    const filtersToggle = root.querySelector('[data-prw-filters-toggle]');
    const filtersPanel = root.querySelector('[data-prw-filters]');
    const loadMoreBtn = root.querySelector('[data-prw-load-more]');
    const countNumber = root.querySelector('[data-prw-count-number]');
    const initialVisible = Number(root.dataset.initialVisible || 5);
    const write = findWriteOverlay(root);

    let visibleCount = initialVisible;

    const getSortValue = () =>
      (sortPicker && sortPicker.getAttribute('data-prw-sort-value')) || 'rating-desc';

    const closeSortPicker = () => {
      if (!sortPicker || !sortToggle || !sortMenu) return;
      sortPicker.classList.remove('is-open');
      sortMenu.hidden = true;
      sortToggle.setAttribute('aria-expanded', 'false');
    };

    const openSortPicker = () => {
      if (!sortPicker || !sortToggle || !sortMenu) return;
      sortPicker.classList.add('is-open');
      sortMenu.hidden = false;
      sortToggle.setAttribute('aria-expanded', 'true');
    };

    const setSortValue = (value) => {
      if (!sortPicker) return;
      const option = sortOptions.find((el) => el.getAttribute('data-prw-sort-option') === value);
      if (!option) return;
      sortPicker.setAttribute('data-prw-sort-value', value);
      sortOptions.forEach((el) => {
        const active = el === option;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (sortLabel) {
        const optionLabel = option.querySelector('.prw__sort-label');
        sortLabel.textContent = optionLabel ? optionLabel.textContent : option.textContent;
      }
    };

    const getItems = () => (list ? Array.from(list.querySelectorAll('.prw__item')) : []);

    const applyVisibility = () => {
      const mediaOnly = getSortValue() === 'media';
      let shown = 0;
      getItems().forEach((item) => {
        const filtered = item.classList.contains('is-filtered-out');
        const noMedia = mediaOnly && item.getAttribute('data-has-media') !== '1';
        if (filtered || noMedia) {
          item.classList.add('is-hidden');
          return;
        }
        shown += 1;
        item.classList.toggle('is-hidden', shown > visibleCount);
      });

      if (loadMoreBtn) {
        const remaining = getItems().filter(
          (item) =>
            !item.classList.contains('is-filtered-out') &&
            !(mediaOnly && item.getAttribute('data-has-media') !== '1') &&
            item.classList.contains('is-hidden')
        ).length;
        loadMoreBtn.hidden = remaining === 0;
        loadMoreBtn.parentElement &&
          loadMoreBtn.parentElement.classList.toggle('is-hidden', remaining === 0);
      }
      updateCount();
    };

    const updateCount = () => {
      if (!countNumber) return;
      const mediaOnly = getSortValue() === 'media';
      const visible = getItems().filter((item) => {
        if (item.classList.contains('is-filtered-out')) return false;
        if (mediaOnly && item.getAttribute('data-has-media') !== '1') return false;
        return true;
      }).length;
      countNumber.textContent = String(visible);
    };

    const applyFilter = (star) => {
      getItems().forEach((item) => {
        const rating = item.getAttribute('data-rating');
        const match = star === 'all' || rating === String(star);
        item.classList.toggle('is-filtered-out', !match);
      });
      visibleCount = initialVisible;
      applyVisibility();

      root.querySelectorAll('[data-star-filter]').forEach((el) => {
        el.classList.toggle('is-active', el.getAttribute('data-star-filter') === star);
      });
    };

    const applySort = () => {
      if (!list || !sortPicker) return;
      const value = getSortValue();
      const items = getItems();

      items.sort((a, b) => {
        const aRating = Number(a.dataset.rating || 0);
        const bRating = Number(b.dataset.rating || 0);
        const aDate = getDateScore(a);
        const bDate = getDateScore(b);
        const aHelpful = Number(a.dataset.helpful || 0);
        const bHelpful = Number(b.dataset.helpful || 0);

        switch (value) {
          case 'date-asc':
            return aDate - bDate;
          case 'helpful-desc':
            return bHelpful - aHelpful || bDate - aDate;
          case 'helpful-asc':
            return aHelpful - bHelpful || bDate - aDate;
          case 'media': {
            const aMedia = a.getAttribute('data-has-media') === '1' ? 1 : 0;
            const bMedia = b.getAttribute('data-has-media') === '1' ? 1 : 0;
            return bMedia - aMedia || bDate - aDate;
          }
          case 'rating-asc':
            return aRating - bRating || bDate - aDate;
          case 'rating-desc':
            return bRating - aRating || bDate - aDate;
          case 'date-desc':
          default:
            return bDate - aDate;
        }
      });

      items.forEach((item) => list.appendChild(item));
      applyVisibility();
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.getAttribute('data-prw-tab');
        tabs.forEach((t) => {
          const active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((panel) => {
          const match = panel.getAttribute('data-prw-panel') === target;
          panel.hidden = !match;
        });
      });
    });

    if (filtersToggle && filtersPanel) {
      filtersToggle.addEventListener('click', () => {
        const open = filtersPanel.hasAttribute('hidden');
        if (open) filtersPanel.removeAttribute('hidden');
        else filtersPanel.setAttribute('hidden', '');
        filtersToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    root.querySelectorAll('[data-star-filter]').forEach((el) => {
      el.addEventListener('click', () => {
        applyFilter(el.getAttribute('data-star-filter') || 'all');
      });
      el.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          applyFilter(el.getAttribute('data-star-filter') || 'all');
        }
      });
    });

    if (sortPicker && sortToggle && sortMenu) {
      sortToggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const isOpen = sortPicker.classList.contains('is-open');
        if (isOpen) closeSortPicker();
        else openSortPicker();
      });

      sortOptions.forEach((option) => {
        option.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const value = option.getAttribute('data-prw-sort-option');
          if (!value) return;
          setSortValue(value);
          closeSortPicker();
          visibleCount = initialVisible;
          applySort();
        });
      });

      document.addEventListener('click', (event) => {
        if (!sortPicker.contains(event.target)) closeSortPicker();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeSortPicker();
      });
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', () => {
        visibleCount += initialVisible;
        applyVisibility();
      });
    }

    root.querySelectorAll('[data-prw-body]').forEach((body) => {
      const btn = body.parentElement && body.parentElement.querySelector('[data-prw-read-more]');
      if (!btn) return;

      body.classList.add('is-clamped');
      body.classList.remove('is-expanded');

      const overflows = body.scrollHeight > body.clientHeight + 1;
      if (!overflows) {
        body.classList.remove('is-clamped');
        btn.hidden = true;
        return;
      }

      btn.hidden = false;
      btn.addEventListener('click', () => {
        body.classList.remove('is-clamped');
        body.classList.add('is-expanded');
        btn.remove();
      });
    });

    root.querySelectorAll('[data-prw-helpful-votes]').forEach((group) => {
      const reviewId = group.dataset.prwReviewId;
      if (!reviewId) return;

      const yesBtn = group.querySelector('[data-prw-helpful="yes"]');
      const noBtn = group.querySelector('[data-prw-helpful="no"]');
      const yesCountEl = yesBtn && yesBtn.querySelector('[data-prw-helpful-count]');
      const noCountEl = noBtn && noBtn.querySelector('[data-prw-helpful-count]');
      const baseYes = Number(group.dataset.prwHelpfulYesBase || 0);
      const baseNo = Number(group.dataset.prwHelpfulNoBase || 0);
      const storageKey = 'prw_helpful_v1';

      const readStore = () => {
        try {
          return JSON.parse(localStorage.getItem(storageKey) || '{}') || {};
        } catch (e) {
          return {};
        }
      };

      const writeStore = (data) => {
        try {
          localStorage.setItem(storageKey, JSON.stringify(data));
        } catch (e) {
          /* ignore */
        }
      };

      const store = readStore();
      let entry = store[reviewId];
      if (!entry || typeof entry !== 'object') {
        entry = { yes: baseYes, no: baseNo, vote: null };
      } else {
        entry.yes = Math.max(Number(entry.yes) || 0, baseYes);
        entry.no = Math.max(Number(entry.no) || 0, baseNo);
        if (entry.vote !== 'yes' && entry.vote !== 'no') entry.vote = null;
      }

      const apply = () => {
        if (yesCountEl) yesCountEl.textContent = String(entry.yes);
        if (noCountEl) noCountEl.textContent = String(entry.no);
        if (yesBtn) yesBtn.classList.toggle('is-active', entry.vote === 'yes');
        if (noBtn) noBtn.classList.toggle('is-active', entry.vote === 'no');
        const item = group.closest('.prw__item');
        if (item) item.dataset.helpful = String(entry.yes);
      };

      const save = () => {
        const next = readStore();
        next[reviewId] = {
          yes: entry.yes,
          no: entry.no,
          vote: entry.vote,
        };
        writeStore(next);
      };

      apply();

      group.querySelectorAll('[data-prw-helpful]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const choice = btn.getAttribute('data-prw-helpful');
          if (choice !== 'yes' && choice !== 'no') return;
          if (entry.vote === choice) return;

          if (entry.vote === 'yes') entry.yes = Math.max(0, entry.yes - 1);
          if (entry.vote === 'no') entry.no = Math.max(0, entry.no - 1);

          entry.vote = choice;
          if (choice === 'yes') entry.yes += 1;
          if (choice === 'no') entry.no += 1;

          apply();
          save();
        });
      });
    });

    try {
      sessionStorage.removeItem('prw_posted');
      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        if (url.searchParams.has('prw_posted')) {
          url.searchParams.delete('prw_posted');
          window.history.replaceState({}, '', url.pathname + url.search + (url.hash || ''));
        }
      }
    } catch (e) {
      /* ignore */
    }

    if (write) bindWriteForm(root, write);

    const hydrateLiveMedia = () => {
      root.querySelectorAll('[data-prw-media-token]').forEach((item) => {
        const token = item.getAttribute('data-prw-media-token');
        const mount = item.querySelector('[data-prw-live-media]');
        if (!token || !mount) return;
        let payload = null;
        try {
          payload = JSON.parse(localStorage.getItem('prw_media_' + token) || 'null');
        } catch (err) {
          payload = null;
        }
        const hideEmptyMedia = () => {
          const mediaWrap = item.querySelector('.prw__card-media');
          if (mediaWrap && !mediaWrap.querySelector('.prw__content-media-thumb')) {
            mediaWrap.hidden = true;
          }
        };
        if (!payload || !Array.isArray(payload.media) || !payload.media.length) {
          hideEmptyMedia();
          return;
        }
        const mediaEntries = payload.media.filter((entry) => entry && entry.dataUrl);
        if (!mediaEntries.length) {
          hideEmptyMedia();
          return;
        }
        mount.hidden = false;
        mount.innerHTML = '';
        const mediaCount = mediaEntries.length;
        mount.classList.remove('prw__content-media--pair', 'prw__content-media--stacked');
        if (mediaCount === 2) {
          mount.classList.add('prw__content-media--pair');
        } else if (mediaCount > 2) {
          mount.classList.add('prw__content-media--stacked');
        }
        const renderedEntries =
          mediaCount > 2
            ? mediaEntries.slice(0, 3)
            : mediaEntries.slice(0, mediaCount === 1 ? 1 : 2);
        renderedEntries.forEach((entry, index) => {
          const thumb = document.createElement('div');
          let thumbClass = 'prw__content-media-thumb';
          if (mediaCount === 2) {
            thumbClass += ' prw__content-media-thumb--pair';
          } else if (mediaCount > 2) {
            thumbClass +=
              index === 0
                ? ' prw__content-media-thumb--large'
                : ' prw__content-media-thumb--small';
          }
          thumb.className = thumbClass;
          if (entry.type === 'video') {
            const video = document.createElement('video');
            video.src = entry.dataUrl;
            video.controls = true;
            video.className = 'prw__content-media-video';
            thumb.appendChild(video);
          } else {
            const img = document.createElement('img');
            img.src = entry.dataUrl;
            img.alt = entry.name || 'Review photo';
            img.className = 'prw__content-media-img';
            img.loading = 'lazy';
            thumb.appendChild(img);
          }
          if (mediaCount > 3 && index === renderedEntries.length - 1) {
            const more = document.createElement('span');
            more.className = 'prw__content-media-more';
            more.textContent = `+${mediaEntries.length - 3} more`;
            thumb.appendChild(more);
          }
          mount.appendChild(thumb);
        });
        const mediaWrap = item.querySelector('.prw__card-media');
        if (mediaWrap) mediaWrap.hidden = false;
        item.setAttribute('data-has-media', '1');
      });
      root.querySelectorAll('.prw__card-media').forEach((wrap) => {
        if (!wrap.querySelector('.prw__content-media-thumb')) wrap.hidden = true;
      });
    };

    hydrateLiveMedia();
    ageStaticReviewDates(root);
    applySort();
  };

  const boot = () => {
    document.querySelectorAll('.prw').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector?.('.prw') || event.target.closest?.('.prw');
    if (root) {
      root.dataset.prwReady = 'false';
      const write = event.target.querySelector?.('[data-prw-write]');
      if (write) write.dataset.prwWriteBound = 'false';
      init(root);
    }
  });
})();
